import React from "react";

import styles from "./Home.module.scss";

import HomeFooter from "../4_templates/HomeFooter";
import HomeHeader from "../4_templates/HomeHeader";
import HomeMain from "../4_templates/HomeMain";

function Home() {
  return (
    <div className={styles["container"]}>
      <HomeHeader />
      <HomeMain />
      <HomeFooter />
    </div>
  );
}

export default Home;
